import "./index.css";

export default function Section4() {
  return (
    <div className="Section4 mb-[40px]  mt-[20px] md:my-[40px] w-full min-h-[350px] md:min-h-[400px] lg:min-h-[550px] min-[1501px]:min-h-[800px]">
    </div>
  );
}
